"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtension = void 0;
exports.getExtension = function (fileName) {
    if (fileName === void 0) { fileName = ''; }
    return fileName.split('.').pop();
};
//# sourceMappingURL=getExtension.js.map